import { TLocoType } from 'shared/hooks/use-loco-translation'
import {
  SubscriptionGivingAccessSettingEnum,
  SubscriptionGivingAccessSettingEnumTitles,
} from '../enums/subscriptions-giving-access-enum'

export const getSubscriptionGivingAccessData = (t: TLocoType) =>
  Object.keys(SubscriptionGivingAccessSettingEnumTitles).map(accessType => {
    const type = accessType as keyof typeof SubscriptionGivingAccessSettingEnum
    return {
      id: type,
      caption: t(SubscriptionGivingAccessSettingEnumTitles[type]),
    }
  }) as { id: SubscriptionGivingAccessSettingEnum; caption: string }[]
